import { z } from 'zod';
import { callAlerts } from 'Views/Monitoring/UnifiedAlerts/transport';

export const activityHistorySchema = z.object({
  title: z.string(),
  deviceId: z.string(),
  complete: z.boolean(),
  historyImported: z.boolean(),
  lastContactAt: z.number().finite().nullable(),
  lastValidReportAt: z.number().finite().nullable(),
  days: z.array(
    z.object({
      day: z.string(),
      minutes: z.number().finite().nonnegative(),
      validReports: z.number().int().nonnegative(),
      invalidReports: z.number().int().nonnegative(),
      entries: z.array(z.object({ start: z.string(), minutes: z.number().finite().nonnegative() })),
    })
  ),
});
export const activitySettingsSchema = z.object({
  orgId: z.string(),
  sensorId: z.string(),
  deviceId: z.string(),
  version: z.number().int().positive(),
  reportingToleranceMinutes: z.number().finite().nullable(),
  weeklyAllowanceMinutes: z.number().finite(),
});
export type ActivitySettings = z.infer<typeof activitySettingsSchema>;
export const activityRequest = callAlerts;
export function activityDay(at: number) {
  return new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Copenhagen',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(at);
}
export function moveDay(day: string, amount: number) {
  const date = new Date(`${day}T12:00:00Z`);
  date.setUTCDate(date.getUTCDate() + amount);
  return date.toISOString().slice(0, 10);
}
